import request from '@/utils/request'

//依据用户id,分组查权限列表
export function queryPermissions(data) {
  return request({
    url: '/api/user/get_permissionList_by_userIdAndGroup',
    method: 'post',
    data: data
  })
}

//判断用户是否有权限
export function havingPermission(data) {
  return request({
    url: '/api/user/havingPermission',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/permission.js